import { create } from "zustand";

type PopoverState = "columns" | number | undefined;

interface ColumnsPopoverStore {
	popoverOpen: PopoverState;
	setPopoverOpen: (state: PopoverState) => void;
	toggleEditColumnPopover: (columnIndex: number) => void;
}

// Create a store factory to ensure each instance has its own state
const createColumnsPopoverStore = () =>
	create<ColumnsPopoverStore>((set, get) => ({
		popoverOpen: undefined,
		setPopoverOpen: (state: PopoverState) => set({ popoverOpen: state }),
		toggleEditColumnPopover: (columnIndex: number) => {
			const { popoverOpen } = get();
			set({
				popoverOpen: typeof popoverOpen === "number" ? undefined : columnIndex,
			});
		},
	}));

// Use a WeakMap to store unique stores for each component instance
const storeMap = new Map<string, ReturnType<typeof createColumnsPopoverStore>>();

export const useColumnsPopoverStore = (instanceKey: string) => {
	if (!storeMap.has(instanceKey)) {
		storeMap.set(instanceKey, createColumnsPopoverStore());
	}
	return storeMap.get(instanceKey)!();
};
